// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"2eba955b","453":"86bc3cb7"}[chunkId] + ".chunk.js";
};